export const isImageType = (type) =>
    ['image/jpeg', 'image/png', 'image/jpg'].includes(type);

export const MAX_FILE_SIZE_MB = 2;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const bytesToMB = (bytes) => {
    return (bytes / (1024 * 1024)).toFixed(2);
}